import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import * as completeCarePlanTask from '../../redux/healthboard/requests/complete-care-plan-task-req';
import { targetUserIdSelector } from '../../redux/context/selectors';
import {
  selectCompleteCarePlanTaskError,
  selectCompleteCarePlanTaskSucceed,
  selectCompleteCarePlanTaskPending,
} from '../../redux/healthboard/selectors';

const mapStateToProps = state => ({
  userId: targetUserIdSelector(state),
  pending: selectCompleteCarePlanTaskPending(state),
  succeed: selectCompleteCarePlanTaskSucceed(state),
  error: selectCompleteCarePlanTaskError(state),
});

const mapDispatchToProps = {
  clear: completeCarePlanTask.actions.clear,
  complete: completeCarePlanTask.actions.start,
};

export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/CarePlanDetailsPopup/enhance.js